import * as React from "react"
import { Script } from "gatsby"

import { useConfig } from "../../hooks/use-config"

function Freshchat() {
  const {
    freshchat: freshChatConfig,
    googleAnalytics: googleAnalyticsConfig
  } = useConfig()

  return (
    <>
      <Script async
        src={`https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsConfig.ga4_measurement_id}`}
        strategy="idle"
      />
      <Script>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${googleAnalyticsConfig.ga4_measurement_id}');
        `}
      </Script>

      <Script>
      {`
        window.fcSettings = {
          onInit: function() {
              if (typeof(gtag) === "function") {
                window.fcWidget.on("widget:opened", function(resp) {
                  console.log("Widget Opened",resp);
                  gtag("event", "widget:opened", {
                    "send_to": '${googleAnalyticsConfig.ga4_measurement_id}',
                    "event_category": "Freshchat widget",
                    "event_label": "Widget Open"
                  });
                });
        
                window.fcWidget.on("widget:closed", function(resp) {
                  console.log("Widget closed",resp);
                  gtag("event", "widget:closed", {
                    "send_to": '${googleAnalyticsConfig.ga4_measurement_id}',
                    "event_category": "Freshchat widget",
                    "event_label": "Widget Closed"
                  });
                });
        
              window.fcWidget.on("message:sent", function(resp) {
                  console.log("message:sent");
                  gtag("event", "message:received", {
                    "send_to": '${googleAnalyticsConfig.ga4_measurement_id}',
                    "event_category": "Freshchat widget",
                    "event_label": "Message sent"
                  });
                });


                window.fcWidget.on("message:received", function(resp) {
                  console.log("Message received",resp);
                  gtag("event", "message:received", {
                    "send_to": '${googleAnalyticsConfig.ga4_measurement_id}',
                    "event_category": "Freshchat widget",
                    "event_label": "Message received"
                  });
                });
              } else {
                console.log("Google gtag() not defined");
              }
          }
        };
        `}
      </Script>

      <Script>
      {`
        window.fcWidgetMessengerConfig = {
          locale: "en",
          config: ${JSON.stringify(freshChatConfig.config)}
        };
        `}
      </Script>

      <Script
        src="//fw-cdn.com/11508754/4168848.js"
        chat="true" widgetId={`${freshChatConfig.widgetUuid}`}
      />

    </>
  )
}

export default Freshchat